/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('EventRelationContactTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		FindAllEventRelationContactsByQueryParamsFactory,
		AutocompleteEventsByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingEventRelationContactFactory,
		NoPagingEventFactory,
		NoPagingRelationFactory,
		NoPagingSalesStatusFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.page = 1;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.newEventRelationContact', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.goToEditState = function(eventRelationContact) {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go($state.current.name + '.editEventRelationContact', {
				eventRelationContactId: eventRelationContact.id,
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
			});
		};

		$scope.getEventRelationContactList = function() {
			FindAllEventRelationContactsByQueryParamsFactory.query(
				{
					eventId: angular.isDefined($scope.eventId) ? $scope.eventId : null,
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					salesStatusId: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,

					page: $scope.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventRelationContactList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedEventRelationContactId = id;
			$('#deleteEventRelationContactConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			EventRelationContactFactory.delete(
				{ id: $scope.selectedEventRelationContactId },
				function() {
					$scope.loadAll();
					$('#deleteEventRelationContactConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteEventRelationContactConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
